// @flow
import { connect } from 'react-redux';
import type { State, Dispatch, Zone } from '../../../types';
import { drawingShapeTypeSelector, drawingShapeSelector } from '../../../selectors/zoneSelectors';
import zoneActions from '../../../actions/zoneActions';
import NewZoneForm from '../ZoneForm';
import type { Props } from '../ZoneForm';

type OwnProps = $ReadOnly<{
    zone: Zone
}>;
const mapStateToProps = (state: State, props: OwnProps) => {
    const zone = props.zone;

    let initialValues;
    if(zone) {
        initialValues = {
            name: zone.name
        };
    }

    return {
        shapeType: drawingShapeTypeSelector(state),
        shape: drawingShapeSelector(state),
        zoneId: zone && zone.id,
        initialValues: initialValues
    };
};

const submitZone = (data) => (dispatch: Dispatch) => {
    let action;

    if(data.id) {
        action = zoneActions.updateZone(data);
    }
    else {
        action = zoneActions.createZone(data);
    }

    dispatch(action)
        .then(() => {
            dispatch(zoneActions.disableDrawingThunk());
        });
};

const mapDispatchToProps = {
    setDrawingShapeType: zoneActions.setDrawingShapeType,
    setDrawingShape: zoneActions.setDrawingShape,
    disableDrawing: zoneActions.disableDrawingThunk,
    onSubmit: submitZone
};

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps)(NewZoneForm);